import { Map } from 'immutable'
import dayjs from 'dayjs'
import { FilterDate, FilterGroup, FilterSearch, FilterSelect, FiltersMap, FilterTab } from './filters.state'
import { Maybe } from 'ballerina-core'

export const mapQueryToFilters = (filters: Maybe<FiltersMap>): Maybe<FiltersMap> => {
  if (!filters) return filters

  const url = new URL(window.location.href)

  const params = Map<string, string>(url.searchParams)

  const newFilters = filters.map((filterGroup, key): FilterGroup => {
    const categories = params.get(key)?.split(',') || []

    switch (filterGroup.kind) {
      case "select":
      case "tab":
        const newCategories = filterGroup.filterItems.map(c0 => {
          let c1: typeof c0 = { ...c0, isSelected: false }

          if (categories.includes(c0.value) == false) return c1
          c1.isSelected = true

          return c1
        })

        return {
          ...filterGroup,
          filterItems: newCategories
        }
      case "radio":
        const items = filterGroup.filterItems
        const key = items.findKey(i => i.value === categories[0])
        if (key == undefined) return filterGroup

        return {
          ...filterGroup,
          filterItems: items.update(key, item => ({ ...item, isSelected: true }))
        }
      case "search":
        const searchQuery = params.get("searchQuery")
        return {
          ...filterGroup,
          searchQuery: searchQuery || ""
        }

      case "date":
        const startDateParam = params.get("startDate")
        const startDate = startDateParam
          ? dayjs(startDateParam, "yyyy-MM-dd").toDate()
          : undefined

        const endDateParam = params.get("endDate")
        const endDate = endDateParam
          ? dayjs(endDateParam, "yyyy-MM-dd").toDate()
          : undefined

        return {
          ...filterGroup,
          startDate: startDate,
          endDate: endDate,
        }

      default:
        throw "invalid filter group provided"
    }
  })

  return newFilters
}

export const updateFilterSingleValue = <T extends FilterSelect | FilterTab>(f0: T, index: number): T => {
  const f1 = { ...f0 }

  f1.filterItems = f0.filterItems.map((item, i) => ({
    ...item,
    isSelected: i === index
  }))

  return f1
}

export const updateFilterSearch = (f0: FilterSearch, input: string): FilterSearch => {
  const fr1: typeof f0 = { ...f0, searchQuery: input }

  return fr1
}

export const updateFilterDate = (f0: FilterDate, input: Date | null, kind: "start" | "end"): FilterDate => {
  if (!input) return f0
  if (kind === "start") return {
    ...f0,
    startDate: input
  }

  if (kind === "end") return {
    ...f0,
    endDate: input
  }

  return f0
}

export const mapFilterToQueryParameters = (filters: FiltersMap) => {
  const oldUrl = new URL(window.location.href)
  oldUrl.searchParams.delete("page")

  const url = new URL(window.location.href)
  url.searchParams.delete("page")

  filters.forEach((f, key) => {
    url.searchParams.delete(key)
    switch (f.kind) {
      case "select":
      case "tab":
      case "radio":
        const selected = f.filterItems.filter(c => c.isSelected)
        const selectedKeys = selected.map(c => c.value)
        if (selected.count() <= 0) return

        url.searchParams.set(key, selectedKeys.join(','))
        return
      case "search":
        url.searchParams.delete("searchQuery")
        if (!f.searchQuery) return

        url.searchParams.set("searchQuery", f.searchQuery)

        return

      case "date":
        url.searchParams.delete("startDate")
        url.searchParams.delete("endDate")

        if (f.startDate) url.searchParams.set("startDate", dayjs(f.startDate).format("YYYY-MM-DD"))
        if (f.endDate) url.searchParams.set("endDate", dayjs(f.endDate).format("YYYY-MM-DD"))

        return
    }
  })
  if (url.href !== oldUrl.href) {
    window.history.pushState({}, '', url)
  }
}


export const clearFilterQueryParameters = () => {
  const oldUrl = new URL(window.location.href)
  
  const url = new URL(window.location.href)
  url.search = ''
  
  if (url.href !== oldUrl.href) {
    window.history.pushState({}, '', url)
  }
}
